import React from 'react';
export function SleepCrisisSection() {
  const symptoms = ['You fall asleep exhausted but wake up 3–4 times per night', 'You sleep 7–8 hours but feel completely unrefreshed', 'Your bedroom WiFi router sits on the nightstand or against the wall', 'The smart meter is mounted on the opposite side of your bedroom wall', "You've had unexplained sleep issues for years, but nothing medical explains it"];
  // The following code block was malformed and has been commented out.
  // for (years, but; nothing; medical)
  //     explains;
  // it;
  // ',;
  const testimonials = ["I went my whole life not sleeping well in my own bedroom. Then I reduced the EMF exposure. I've never slept better.", 'My husband and I had the best night sleep! For the first time I had NO constant tingling & pain in my body, and my legs did not feel jumpy!', 'RF inside the canopy measures zero... My sleep has immediately gone to a new level of deep and regenerative!!'];
  return <section className="w-full bg-white py-8 md:py-12 lg:py-16 px-4 md:px-6" style={{
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
  }} data-id="element-168">
      <div className="max-w-6xl mx-auto" data-id="element-169">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start" data-id="element-170">
          {/* Content */}
          <div className="order-2 lg:order-1" data-id="element-171">
            <h2 className="text-[29px] md:text-[34px] lg:text-[43px] font-bold mb-6" style={{
            color: '#1B4F9E'
          }} data-id="element-172">
              THE SLEEP CRISIS EVERYONE IGNORES
            </h2>

            <div className="my-6 -mx-4 md:-mx-6 lg:mx-0" data-id="element-173">
              <img src="https://cdn.magicpatterns.com/uploads/8fGt812tBxqSH314HkainS/unnamed_(5).jpg" alt="Woman lying in bed looking exhausted and unable to sleep" className="w-full rounded-lg shadow-lg" style={{
              boxShadow: '0px 8px 24px rgba(27, 79, 158, 0.12)'
            }} data-id="element-174" />
            </div>

            <div className="text-base md:text-lg leading-relaxed space-y-5" style={{
            color: '#2C3E50',
            lineHeight: '1.7'
          }} data-id="element-175">
              <p className="font-semibold" data-id="element-176">
                But this isn't just about teenagers.
              </p>

              <p data-id="element-177">
                <strong data-id="element-178">
                  1 in 4 Australian adults now report chronic sleep deprivation.
                </strong>{' '}
                And when doctors ask "How much screen time are you getting?"
                they never mention the invisible EMF radiation that WiFi and 5G
                emit{' '}
                <strong data-id="element-179">
                  24/7, even when devices aren't actively being used.
                </strong>
              </p>
            </div>

            {/* Symptom Checklist */}
            <div className="mt-8" data-id="element-180">
              <p className="font-semibold mb-4" style={{
              color: '#2C3E50'
            }} data-id="element-181">
                Do any of these sound familiar?
              </p>
              <ul className="space-y-3" data-id="element-182">
                {symptoms.map((symptom, index) => <li key={index} className="flex items-start gap-3 text-base" style={{
                color: '#2C3E50',
                lineHeight: '1.6'
              }} data-id="element-183">
                    <span style={{
                  color: '#2D9B6E'
                }} data-id="element-184">
                      ✓
                    </span>
                    <span data-id="element-185">{symptom}</span>
                  </li>)}
              </ul>
            </div>

            {/* Why Sleep Matters */}
            <div className="mt-8 text-base md:text-lg leading-relaxed space-y-5" style={{
            color: '#2C3E50',
            lineHeight: '1.7'
          }} data-id="element-186">
              <p data-id="element-187">
                <strong data-id="element-188">
                  This isn't stress, burnout or lifestyle — it's EMF radiation
                  frying your brain.
                </strong>{' '}
                Poor sleep accelerates cognitive decline. It destroys immune
                function. It exacerbates anxiety. For teenagers,{' '}
                <strong data-id="element-189">
                  sleep deprivation affects brain development—the consequences
                  last lifelong.
                </strong>
              </p>

              <div className="my-4 -mx-4 md:-mx-6 lg:mx-0" data-id="element-190">
                <img src="https://cdn.magicpatterns.com/uploads/4EpVFvdxLEpzvgMtwLSN4Q/unnamed_(6).jpg" alt="Woman lying awake in bed next to WiFi router and phone emitting EMF radiation" className="w-full rounded-lg shadow-lg" style={{
                boxShadow: '0px 8px 24px rgba(27, 79, 158, 0.12)'
              }} data-id="element-191" />
              </div>

              <p className="font-semibold" data-id="element-192">From the research:</p>
            </div>

            {/* Research Image */}
            <div className="mt-4 mb-2" data-id="element-193"></div>

            {/* Testimonial Callout */}
            <div className="mt-6 p-5 rounded-r border-l-4" style={{
            backgroundColor: '#F0F7FF',
            borderColor: '#2D9B6E'
          }} data-id="element-194">
              {testimonials.map((testimonial, index) => <p key={index} className="text-base font-medium italic mb-4 last:mb-0" style={{
              color: '#1B4F9E',
              lineHeight: '1.8'
            }} data-id="element-195">
                  {testimonial}
                </p>)}
            </div>
          </div>

          {/* Image */}
          <div className="order-1 lg:order-2" data-id="element-196"></div>
        </div>
      </div>
    </section>;
}